var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cs-input",
    class: [_vm.classes]
  }, [_c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.displayName))])]), _c('input', {
    ref: "input",
    attrs: {
      "id": _vm.inputId,
      "type": _vm.type,
      "title": _vm.title,
      "placeholder": _vm.placeholder,
      "minlength": _vm.minLength,
      "maxlength": _vm.maxLength,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": _vm.handleFocus,
      "input": _vm.handleInput,
      "blur": _vm.handleBlur,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit($event);
      }
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }